// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"718b5c4c","796":"f9fbd3bd"}[chunkId] + ".chunk.js";
};